import { render } from "./AboutView.vue?vue&type=template&id=7c1f34b4&scoped=true"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=7c1f34b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1f34b4"]])

export default __exports__